/**
 * Top-level error boundary. Catches render errors anywhere below it, logs once,
 * and shows a recoverable fallback instead of a white screen.
 *
 * Route-level boundaries can be added per feature for finer-grained recovery.
 */
import { Component } from 'react';

import { env } from '@config/env';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
    // Hook your telemetry here (env.telemetryDsn).
  }

  handleReset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div role="alert" style={{ padding: '2rem', fontFamily: 'system-ui' }}>
        <h1>Something went wrong</h1>
        <p>An unexpected error occurred. You can try again.</p>
        {env.isDev && <pre style={{ whiteSpace: 'pre-wrap' }}>{String(this.state.error)}</pre>}
        <button type="button" onClick={this.handleReset}>
          Try again
        </button>
      </div>
    );
  }
}
